import { lazy } from "react";

const RELOAD_FLAG = "chunkReloadAt";

const isChunkLoadError = (error) =>
  error?.name === "ChunkLoadError" ||
  /Loading (CSS )?chunk [\w-]+ failed/i.test(error?.message || "");

// React.lazy que recarrega a página uma vez quando o chunk não existe mais —
// acontece quando um deploy novo substituiu os arquivos e a janela ainda está
// com o index.html antigo. A flag evita loop se o chunk falhar de verdade.
const lazyWithReload = (factory) =>
  lazy(async () => {
    try {
      const module = await factory();
      sessionStorage.removeItem(RELOAD_FLAG);
      return module;
    } catch (error) {
      const lastReload = Number(sessionStorage.getItem(RELOAD_FLAG) || 0);
      if (isChunkLoadError(error) && Date.now() - lastReload > 10000) {
        sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
        window.location.reload();
        return new Promise(() => {});
      }
      throw error;
    }
  });

export default lazyWithReload;
